var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-hover',{staticClass:"pointer rounded",scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('div',{class:[hover ? 'elevation-5' : '','py-2']},[_c('v-img',{attrs:{"alt":_vm.item.name,"width":"100%","height":"150","src":_vm.item.image[0],"contain":""},on:{"click":_vm.onClick}})],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }